@use "~theme/breakpoints";
@use "./tokens.scss";

.below {
  position: relative;
  display: flex;
  justify-content: flex-end;
}

.bar {
  background-color: var(--white);
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  height: tokens.$nav-height-mobile;
  padding: 0 var(--mobile-gutter);
  border-bottom: 1px solid var(--blue-01-at-30);

  @include breakpoints.desktop {
    //padding: 0 var(--desktop-gutter);
    height: tokens.$nav-height-desktop;
  }
}

.logoContainer {
  display: inline-flex;
  align-items: center;
  height: 100%;
  margin-right: 0;
  z-index: var(--modal-overlay);

  @include breakpoints.mobile-large {
    margin-right: 64px;
  }
}

.logo {
  max-height: 46px;
  max-width: 320px;
  height: 40px;
  width: 149px;
  object-fit: contain;
}

.cobranded {
  //margin: auto;

  @include breakpoints.desktop {
    margin-left: 0;
    margin-right: 64px;
  }
}

.signInLayout {
  float: right;
}

.logout {
  color: var(--bright-blue);
  padding: 20px 20px;
  right: 20px;
  position: absolute;
  cursor: pointer;
}
